import axios from "axios";
import { ENDPOINT } from "../config";
import { setData, setSessionData } from "../redux/actions";
import { store } from "../redux/store";

export const MakeApiCall = async (
  url,
  method = "get",
  data = null,
  withBearer = false,
  headers_ = {},
  token = store?.getState()?.user?.data?.token
) => {
  try {
    let headers = {
      "Content-Type": "application/json",
      ...headers_,
    };
    if (data instanceof FormData) {
      delete headers["Content-Type"];
    }

    if (withBearer) {
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      } else {
        localStorage.clear();
        return window.location.assign("/login");
      }
    }
    let url_ = ENDPOINT + url;
    const response = await axios({
      method,
      url: url_,
      data: data || null,
      headers,
      redirect: "follow",
    });

    return response.data;
  } catch (error) {
    // List of public endpoints that shouldn't trigger 401 redirect
    const publicEndpoints = [
      "sign-up",
      "send-email-validation",
      "sign-in",
      "login",
      "forgot-password",
      "reset-password",
      "demo-user-login",
      "sub-users/invite/validate",
      "sub-users/invite/accept",
    ];
    const isPublicEndpoint = publicEndpoints.some(endpoint => url.includes(endpoint));
    
    if (error?.response?.status === 401 && !isPublicEndpoint) {
      setData({});
      setSessionData({});
      localStorage.clear();
      return window.location.assign("/login");
    }
    
    // Return the API error response if available, otherwise return error message
    if (error?.response?.data) {
      return error.response.data;
    }
    
    // Handle errors here (e.g., log them or throw a custom error)
    return { message: error?.message, status: false };
  }
};
